import axios from 'axios'
import _get from 'lodash/get'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { receiveSuccessAlert } from './alerts'
import { handleRequestError } from './request'

export const REQUEST_IDENTITY_VERIFICATIONS = 'REQUEST_IDENTITY_VERIFICATIONS'
export const RECEIVE_IDENTITY_VERIFICATIONS = 'RECEIVE_IDENTITY_VERIFICATIONS'
export const SAVE_IDENTITY_VERIFICATION = 'SAVE_IDENTITY_VERIFICATION'
export const CREATE_IDENTITY_VERIFICATION = 'CREATE_IDENTITY_VERIFICATION'

export const requestIdentityVerifications = () => (dispatch) => {
    dispatch({ type: REQUEST_IDENTITY_VERIFICATIONS })

    axios
        .get('/identityverification')
        .then((response) => {
            const items = _get(response, ['data'], [])
            dispatch(receiveIdentityVerifications({ items, fetchSuccessful: true }))
        })
        .catch((error) => {
            dispatch(receiveIdentityVerifications({ fetchSuccessful: false }))
            dispatch(handleRequestError(error))
        })
}

export const receiveIdentityVerifications = (data) => (dispatch) => {
    dispatch({ type: RECEIVE_IDENTITY_VERIFICATIONS, data })
}

export const createIdentityVerification = (data) => (dispatch) => {
    dispatch({ type: CREATE_IDENTITY_VERIFICATION, data })

    return axios
        .post(`/identityverification`, data)
        .then((response) => {
            const item = _get(response, ['data'], {})
            dispatch(receiveIdentityVerifications({ items: [item] }))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}

export const saveIdentityVerification = (data) => (dispatch) => {
    dispatch({ type: SAVE_IDENTITY_VERIFICATION, data })

    const { id } = data

    return axios
        .put(`/identityverification/${id}`, data)
        .then((response) => {
            const item = _get(response, ['data'], {})
            dispatch(receiveIdentityVerifications({ items: [item] }))
            dispatch(receiveSuccessAlert('ID verification submitted'))
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
            return Promise.reject(error)
        })
}
